module.exports = __webpack_public_path__ + "static/media/lingerie-logo@2x.f6a74878.png";